<template>
  <v-menu v-model="menuOpen" offset-y bottom>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined>
        <v-icon left>fas fa-caret-down</v-icon>
        {{ selectedTermDesc }}
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item v-for="(term, index) in terms" :key="'term-' + index" @click="selectTerm(term)">
        <v-list-item-title>{{ term.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { ref, computed, onMounted } from '@vue/composition-api'
export default {
  setup (props, { root, emit }) {
    const user = computed(() => root.$store.state.user)
    const isAdmin = computed(() => root.$store.getters.isAdmin)

    const menuOpen = ref(false)

    const selectedTermCode = computed(() => root.$store.state.admin.term)
    const selectedTermDesc = computed(() => root.$store.state.admin.termLabel)
    const terms = ref([])

    function selectTerm ({ term, label }) {
      root.$store.commit('admin/setTerm', term)
      root.$store.commit('admin/setTermLabel', label)
      emit('changeTerm', term)
    }

    onMounted(() => {
      let dt = new Date()
      dt.setDate(dt.getDate() - 20)
      if (selectedTermCode.value === '') {
        root.$feathers.service('orientation/term').find({ query: { startDate: { $gt: dt }, $limit: 1, $sort: { openDate: 1, label: 1 } } }).then(({ data }) => {
          selectTerm(data[0])
        })
      }
      root.$feathers.service('orientation/term').find({ query: { $limit: 10, $sort: { startDate: -1 } } }).then(({ data }) => {
        terms.value = data
      })
    })

    return {
      user,
      isAdmin,
      menuOpen,
      selectedTermCode,
      selectedTermDesc,
      terms,
      selectTerm
    }
  }
}
</script>
